<template>
  <div id="app">
    <FlashBanner
      :message="messageObject.message"
      :status="messageObject.status"
      :duration="messageObject.duration"
    />

    <div id="nav">
      <span class="nav-user" v-if="username">Hi, {{ username }}</span>
      <router-link to="/" v-if="username">
        <span class="n-link">
          <img src="./assets/images/crack-egg.png" />
        </span>
      </router-link>
      <span v-else class="brand">
        <img src="./assets/images/idea-hatchery-wordmark.png" alt="Idea Hatchery" />
      </span>
      <button v-if="user" class="logout" @click="logout">Logout</button>
    </div>
    <router-view :user="user" :currentUser="currentUser" />
    <Footer />
  </div>
</template>

<script>
// Import sass styles
import "./assets/styles/main.scss";

import FlashBanner from "@/components/FlashBanner";
import Footer from "@/components/Footer";

import { EventBus } from "@/eventbus";

import firebase from "firebase/app";
// eslint-disable-next-line
import auth from "firebase/auth";
import db from "@/fb/init";

export default {
  components: { FlashBanner, Footer },
  data() {
    return {
      user: null,
      username: null,
      currentUser: null,
      messageObject: {
        message: null,
        status: null,
        duration: null
      }
    };
  },
  mounted() {
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        this.user = user;
        this.saveUserId(user);
        db.collection("users")
          .doc(user.uid)
          .get()
          .then(doc => {
            this.currentUser = doc.data();
            this.currentUser.userId = doc.id;
            this.username = this.currentUser.name;
          });
      } else {
        this.user = null;
      }
    });

    EventBus.$on("showFlash", messageObject => {
      this.messageObject.message = messageObject.message;
      this.messageObject.status = messageObject.status;
      this.messageObject.duration = messageObject.duration;
    });

    EventBus.$on("clearFlash", () => {
      this.messageObject.message = null;
      this.messageObject.status = null;
      this.messageObject.duration = null;
    });
  },
  methods: {
    logout() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.user = null;
          this.username = null;
          this.currentUser = null;
          sessionStorage.clear();
          this.$router.push("/login");
        })
        .catch(err => window.console.log("err on logout", err));
    },

    saveUserId(user) {
      sessionStorage.setItem("userId", user.uid);
    }
  }
};
</script>
